export const runHubspotCompliance = async (rerender = false) => {
    if (process.client) {
        if (rerender) {
            try {
                // remount footer link on re-render
                const hiddenFooterCookieSettings = document.querySelector('.hs-footer-cookie-settings[hidden]');

                if (hiddenFooterCookieSettings && window?._hsg.compliance) {
                    window._hsg.compliance.addSettingsLink();
                }
            } catch (error) {}

            try {
                // remount footer link on re-render
                const hiddenFooterCookieSettings = document.querySelector('.hs-footer-cookie-settings[hidden]');

                if (hiddenFooterCookieSettings && window?._hsg.compliance) {
                    window._hsg.compliance.addSettingsLink();
                } else {
                    const manageCookiesHTML = `<li class="hs-footer-cookie-settings fs-11" data-test-id="footer-settings-btn"><a href="" class="fs-11">Manage Cookies</a></li>`;
                    const privacyPolicyHTML = `<li><a href="https://legal.hubspot.com/privacy-policy?hubs_content=www.hubspot.com/&amp;hubs_content-cta=Privacy%20Policy&amp;_gl=1*atai5b*_ga*NjU0NzI3ODUwLjE2OTc1NTYxODA.*_ga_LXTM6CQ0XK*MTcxMDk0OTkyNi4zMy4xLjE3MTA5NDk5MjcuNTkuMC4w&amp;__hstc=157326821.cc67ce2c644ba9235689a92668032307.1712074445569.1712074445569.1712074445569.1&amp;__hssc=157326821.1.1712074445569&amp;__hsfp=739496078" target="_blank" class="mess-link external-link privacy-policy fs-11"> Privacy Policy </a></li>`;

                    const insertDesktop = document.getElementById('hubspot-links-wrapper-desktop');
                    const insertMobile = document.querySelector('.footer-row.mobile .hs-footer-links-wrapper');

                    const isDesktop = window.innerWidth >= 1041;

                    if (isDesktop) {
                        if (insertDesktop) {
                            insertDesktop.innerHTML = '';
                            insertDesktop.insertAdjacentHTML('beforeend', manageCookiesHTML);
                            insertDesktop.insertAdjacentHTML('beforeend', privacyPolicyHTML);
                        }
                    } else {
                        if (insertMobile) {
                            insertMobile.innerHTML = '';
                            insertMobile.insertAdjacentHTML('beforeend', manageCookiesHTML);
                            insertMobile.insertAdjacentHTML('beforeend', privacyPolicyHTML);
                        }
                    }

                    if (window?._hsg.compliance) window._hsg.compliance.addSettingsLink();
                }
            } catch (error) {}
        } else {
            try {
                requestAnimationFrame(() => {
                    window._hsg.compliance.scanCookies();
                    setTimeout(() => {
                        const hiddenFooterCookieSettings = document.querySelector('.hs-opt-out-settings');
                        if (!hiddenFooterCookieSettings && window._hsg?.compliance) {
                            window._hsg.compliance.addSettingsLink();
                        }
                    }, 1000);
                })
            } catch (error) {}
        }
    }

    return 'Hubspot compliance';
};
